export var SelfBusinessPlanMenuItems;
(function (SelfBusinessPlanMenuItems) {
    SelfBusinessPlanMenuItems["Download"] = "Download";
    SelfBusinessPlanMenuItems["Save"] = "Save";
})(SelfBusinessPlanMenuItems || (SelfBusinessPlanMenuItems = {}));
